export default __webpack_public_path__ + "static/media/813.d2436749.png";